module.exports = __webpack_public_path__ + "static/media/logo.44bc8091.png";